import { render, staticRenderFns } from "./FinanceTrackerDocumentPopover.vue?vue&type=template&id=49f06095&"
import script from "./FinanceTrackerDocumentPopover.vue?vue&type=script&lang=js&"
export * from "./FinanceTrackerDocumentPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports